import React from "react";
import Widget from "./Components/Widget";

function App() {
  return (
    <div className="App">
      <Widget/>
    </div>
  );
}

export default App;
